import { reactClass } from '../../../utils'
import * as Styled from './styles'

export const Thumb = () => <Styled.ThumbnailWrapper className={reactClass('loading-placeholder-thumb')} />
